import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MonospacedBlockComponent } from 'src/app/shared/components/monospaced-block/monospaced-block.component';
import { CA } from 'src/app/shared/entities/ca';
import { LangService } from 'src/app/shared/services/lang/lang.service';

@Component({
  selector: 'app-show-crl-dialog',
  imports: [MatDialogModule, MatButtonModule, MonospacedBlockComponent],
  templateUrl: './show-crl-dialog.html',
  styleUrl: './show-crl-dialog.scss',
})
export class ShowCrlDialogComponent {
  private data: { crl: string; ca: CA } = inject(MAT_DIALOG_DATA);
  crl = this.data.crl;
  private ca = this.data.ca;

  langService = inject(LangService);

  labels =
    this.langService.lang.features.calist.details.actions.generateCrl.dialog;

  title = this.labels.title(this.ca?.caName ?? '');
}
